import { Grid } from '@mui/material';

import { FormikContextType, useFormikContext } from 'formik';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import * as yup from 'yup';

import { ModuleItem } from 'app/components/RichList/items/AWPM-FWPM/ModuleItem';
import { SubjectType } from 'app/containers/AWPM-FWPM/ModuleSelections/models';
import { validateForm } from 'utils/FormErrorHelper';

import { ModuleWithComplete } from '../../models';
import { moduleInSelectionValidationSchema, moduleValidationSchema } from '../validation';

interface Props {
  subjectType: SubjectType;
}
export default function ModulePreview(props: Props) {
  const { values }: FormikContextType<ModuleWithComplete> = useFormikContext();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const complete = yup.object().shape(moduleInSelectionValidationSchema(t)).isValidSync(values);

  useEffect(() => {
    validateForm(values, yup.object().shape(moduleValidationSchema(t)), dispatch);
  });

  return (
    <Grid container justifyContent="center">
      <Grid item xs={8}>
        <ModuleItem
          module={{ ...values, complete }}
          deactivateButtons={true}
          isPreview={true}
          deactiveLink={true}
          subjectType={props.subjectType}
        />
      </Grid>
    </Grid>
  );
}
